import { React, useState, useRef, useEffect } from "react";
const FootBallScoreBoard = () => {
  return <div></div>;
};

export default FootBallScoreBoard;
